import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class BuyerApiService {
  // API Link
  public static _BACKEND_API_LINK = environment.backendapi;
  headers: Headers;
  options: RequestOptions;

  // Constructor Define --- header's Option in constructor
  constructor(public router: Router, private http: Http) {
    this.headers = new Headers({ 'Content-Type': 'application/json' });
    this.options = new RequestOptions({ headers: this.headers });
  }

  // Add New Projects
  public addNewProject(addnewproject: any): Observable<any> {
    // tslint:disable-next-line:prefer-const
    let body = JSON.stringify(addnewproject);
    return this.http.post(BuyerApiService._BACKEND_API_LINK + '/add_new_project', body, this.options)
      .map(this.extractRequests)
      .catch(this.handleError);
  }

   // Get All show_agreed_projects
   getAllIntrestedSellersByProjectId(project_id: Number): Observable<any> {
    return this.http.get(BuyerApiService._BACKEND_API_LINK + '/show_seller_list/' + project_id , this.options)
    .map(this.extractRequests)
    .catch(this.handleError);
  }

    // Get service categories
    getServiceCategories(): Observable<any> {
      return this.http.get(BuyerApiService._BACKEND_API_LINK + '/show_service_categories', this.options)
      .map(this.extractRequests)
      .catch(this.handleError);
    }

   // Get All show_agreed_projects
   getAllAcceptedProjects(): Observable<any> {
    return this.http.get(BuyerApiService._BACKEND_API_LINK + '/show_all_accepted_projects_for_buyer'  , this.options)
    .map(this.extractRequests)
    .catch(this.handleError);
  }

  // Add New Projects
  public buyerProjectSignAgreement(agreement: any): Observable<any> {
    // tslint:disable-next-line:prefer-const
    let body = JSON.stringify(agreement);
    return this.http.post(BuyerApiService._BACKEND_API_LINK + '/buyer_sign_agreement', body, this.options)
      .map(this.extractRequests)
      .catch(this.handleError);
  }

  // Response split
  private extractRequests(res: Response) {
    if (res['_body']) {
        const data = JSON.parse(res['_body']);
        if (data != null && data.value) { return data.value; }
        // tslint:disable-next-line:one-line
        else { return data; }
    }
}

  // Error Handler
  private handleError(error: Response | any) {
    // check JWT expired error - if expired refresh page, this'll redirect to login automatically by auth guard
    if (error.message === 'No JWT present or has expired') {
      location.reload();
    }

    let errMsg: string;
    if (error instanceof Response) {
      // const body = error.json() || '';
      const err = JSON.stringify(error);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    // console.error(errMsg);
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// ./src/app/buyer/service/buyer-api.service.ts